/* sb-dc-flagthumb.js — Design Templates 페이지에서 깃발 템플릿을 그 깃발
   모양으로 보여 준다. 2026-09-10.

   무엇이 문제였나
   ---------------
   깃발 인쇄 파일은 «네모» 다. 디자인이 네모를 가득 채우고, 공장이 거기서
   페더/티어드롭 모양을 잘라 낸다. 그래서 그리드에는 네모 타일로만 뜨는데,
   디자인센터를 열면 깃발 모양 판이 나온다 — 라운드 스티커 때와 똑같은 어긋남
   (assets/sb-dc-roundthumb.js 가 그때 한 일).

   어떻게 고치나
   -------------
   그림을 다시 그리지 않는다. 브라우저의 clip-path 로 «자를 자리» 만 알려 준다.
   모양 좌표는 아래 SHAPES — 디자인센터의 assets/sb-dc-flagshape.js 안 SHAPES 와
   «같은 표를 두 번 적은 것» 이다(그 파일은 빌드된 파일이라 읽어 쓸 수 없다).
   ⚠ 한쪽을 고치면 다른 쪽도 고칠 것.

   좌표는 0~1 (objectBoundingBox) 이라 타일 크기가 얼마든 알아서 늘어난다.
   그래서 이 파일은 페이지가 열릴 때 딱 한 번 돌고 끝난다 — 나중에 그려지는
   타일에도 CSS 가 그대로 걸리므로 감시(폴링)가 필요 없다.

   언제 도나
   ---------
   주소에 ?product=<깃발 핸들> 이 있을 때만. 상품이 안 정해진 «All products»
   화면은 손대지 않는다(네모 배너와 깃발이 섞여 있어 한 가지 모양으로 자를 수
   없다). 깃발이 아니면 아무것도 안 한다.

   진단: window.__dcFlagThumb */
(function () {
  'use strict';

  /* 디자인센터 sb-dc-flagshape.js 의 SHAPES 와 같은 표. 바꾸면 양쪽 다. */
  var SHAPES = {
    /* 2026-09-22: Feather Angled S·M·L and (below) Feather Convex / Teardrop S·M·L are re-fitted to their real
       curve box. They had been boxed with the Bezier control points, so each outline was drawn smaller than its
       board (Teardrop L: 5.2in short at the top). Same B2Sign shapes; X-Large, Rectangle and Econo keep their values. */
    'feather-angled-flag-small':
      'M1 0.0007C1 0.0007 0.7994 -0.003 0.6615 0.0068C0.6394 0.0091 0.4343 0.0245 0.2858 0.0816C0.2646 0.0889 0.1535 0.1347 0.0969 0.1902C0.0828 0.2032 0.025 0.2635 0.0073 0.3264C0.0062 0.3348 0 0.3634 0 0.3634L0.0097 1L1 0.867C0.9997 0.8264 1 0.0007 1 0.0007Z',
    'feather-angled-flag-medium':
      'M1 0.8672L0 1L0 0.4035C0 0.4035 -0.0053 0.2169 0.2519 0.1119C0.5138 0.0051 1 0 1 0L1 0.8672Z',
    'feather-angled-flag-large':
      'M1 0.8837L0.0013 1L0.0013 0.3623C0.0013 0.3623 -0.0343 0.211 0.2715 0.1006C0.5502 0 1 0 1 0L1 0.8837Z',
    'feather-angled-flag-x-large':
      'M0.9946 0.9255L0.9946 0.9249L0 1L0.0094 0.1572C0.0094 0.1572 0.0492 0.0339 1 0L0.9946 0.9255Z',
    'feather-convex-flag-small':
      'M0.9998 0.5506L0.9999 0.5501C0.9999 0.2986 1 0.0007 1 0.0007C1 0.0007 0.7994 -0.003 0.6615 0.0068C0.6394 0.0091 0.4343 0.0245 0.2858 0.0816C0.2646 0.0888 0.1535 0.1347 0.0969 0.1902C0.0828 0.2032 0.025 0.2635 0.0073 0.3264C0.0062 0.3348 0 0.3634 0 0.3634L0.0097 1L0.0098 1C0.0098 1 0.4336 0.9853 0.727 0.8909C0.9349 0.8241 0.9884 0.7369 1 0.6829L0.9998 0.6311L0.9998 0.5506Z',
    'feather-convex-flag-medium':
      'M0.7122 0.9061C0.4373 0.9774 0 1 0 1L0 0.4035C0 0.4035 -0.0053 0.2169 0.252 0.1119C0.5138 0.0051 0.9999 0 0.9999 0L0.9999 0.7058C0.9999 0.7058 1.0119 0.8284 0.7122 0.9061Z',
    'feather-convex-flag-large':
      'M1 0.7298C1 0.7298 0.9801 0.8495 0.6457 0.9174C0.3607 0.9754 0.0013 1 0.0013 1L0.0013 0.3623C0.0013 0.3623 -0.0343 0.211 0.2715 0.1006C0.5502 0 1 0 1 0L1 0.7298Z',
    'teardrop-flag-small':
      'M0.0092 1C0.0163 0.9945 -0.0175 0.6082 0.0129 0.3692C0.0265 0.2618 0.1378 0.1784 0.1964 0.137C0.3114 0.0556 0.5362 -0.018 0.7237 0.0039C1.0467 0.0415 0.9519 0.1879 0.9519 0.1879L1 0.1947L0.0092 1Z',
    'teardrop-flag-medium':
      'M0.028 1C0.0345 0.9948 -0.0159 0.7471 0.0052 0.5072C0.0195 0.3443 0.0367 0.3169 0.0622 0.2613C0.139 0.0936 0.4898 -0.0435 0.77 0.0129C1.0122 0.0617 0.9679 0.1944 0.9679 0.1944L1 0.2011L0.028 1Z',
    'teardrop-flag-large':
      'M0.0032 1L0.0015 1L0.0015 1L0.0016 0.9507L0.0031 0.4507L0.0001 0.3972C-0.0025 0.274 0.0665 0.1852 0.1698 0.109C0.1698 0.109 0.3779 -0.0535 0.7748 0.0183C0.7748 0.0183 1.0482 0.063 0.9723 0.1948L1 0.2003L0.0032 1Z',
    'rectangle-flag-small':
      'M1 1L0.0001 0.9993L0 0.0551L0.1609 0L1 0L1 1Z',
    'rectangle-flag-medium':
      'M1 1L0.0001 0.9994L0 0.0438L0.1613 0L1 0.0001L1 1Z',
    'rectangle-flag-large':
      'M1 1L0.0001 0.9999L0 0.033L0.1613 0L1 0.0001L1 1Z',
    'econo-feather-flag':
      'M1 0.8837L0.0344 1L0.0344 0.3623C0.0344 0.3623 0 0.211 0.2957 0.1006C0.5651 0 1 0 1 0L1 0.8837Z'
  };

  /* 사이즈가 안 정해졌을 때 그 갈래를 대표할 모양 (__dcFamily 가 주는 키) */
  var FAM = {
    'feather-angled': 'feather-angled-flag-large',
    'feather-convex': 'feather-convex-flag-large',
    'teardrop-flag':  'teardrop-flag-large',
    'rectangle-flag': 'rectangle-flag-large',
    'econo-feather':  'econo-feather-flag'
  };

  var info = { handle: '', shape: '', applied: false };
  window.__dcFlagThumb = info;

  function handle() {
    try { return String(new URLSearchParams(location.search).get('product') || ''); }
    catch (e) { return ''; }
  }

  function shapeFor(h) {
    if (SHAPES[h]) return h;
    var fam = (window.__dcFamily && window.__dcFamily(h)) || [];
    for (var i = 0; i < fam.length; i++) if (FAM[fam[i]]) return FAM[fam[i]];
    return '';
  }

  function start() {
    /* 두 번 돌지 않는다. 섹션이 중복으로 들어가면 같은 id 가 두 개 생긴다
       (옆 파일 sb-dc-roundthumb.js 도 같은 가드를 둔다). */
    if (document.getElementById('sbdt-flagthumb-css')) return;

    var h = info.handle = handle();
    var key = info.shape = shapeFor(h);
    if (!key) return;                       /* 깃발이 아니다 — 그리드 그대로 */

    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0';
    var cp = document.createElementNS(NS, 'clipPath');
    cp.setAttribute('id', 'sbdt-flagclip');
    cp.setAttribute('clipPathUnits', 'objectBoundingBox');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', SHAPES[key]);
    cp.appendChild(p); svg.appendChild(cp);
    document.body.appendChild(svg);

    var st = document.createElement('style');
    st.id = 'sbdt-flagthumb-css';
    /* 자르는 줄 «하나» 만 건다.

       2026-09-10 점검에서 배운 것 — 처음엔 height:100%·width:auto·object-fit:fill
       을 함께 걸었다. «칸이 그림보다 넓으면 흰 여백까지 깃발 모양으로 잘린다» 고
       보았기 때문이다. 브라우저로 네 가지 판을 재보니 **넷 다 상자가 110×519 로
       같았다** — 칸은 원래부터 그림 비율이다(sb-dc-eventhumbs.js 가 width/height
       auto + max-* 로 이미 비율을 지킨다). 즉 그 셋은 근거가 없었고, 함께 넣은
       margin:0 auto 가 eventhumbs 의 margin:auto 를 덮어 세로 가운데 정렬만
       망가뜨렸다(라이브 위6/아래6 → 사본 위0/아래12).

       ⚠ height 를 «퍼센트» 로 주지 말 것. sb-dc-eventhumbs.js 주석에 적힌 사파리
         사고(칸 높이가 aspect-ratio 로 정해지면 퍼센트 높이를 무시해 그림이 잘림)와
         같은 자리다. 그 파일이 일부러 없앤 것을 되살리지 않는다.

       .sbdt-new 는 «직접 만들기» 타일이라 뺀다. */
    st.textContent =
      '#sbdt-root .sbdt-card:not(.sbdt-new) .sbdt-thumb img{' +
      'clip-path:url(#sbdt-flagclip)}';
    document.head.appendChild(st);
    info.applied = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
